export { default as CreateActivityModalController } from './CreateActivityModalController';
export { CreateActivityModal }                      from './CreateActivityModal';


// WEBPACK FOOTER //
// ./src/components/createActivityModal/index.js